import { checkPermission } from '@/router/guards.ts'

const StaffModule = () => import('./StaffModule.vue')
const StaffIndex = () => import('./views/StaffIndex.vue')

export const staffRoute = {
  path: '/staff',
  name: 'Staff',
  component: StaffModule,
  meta: {
    title: 'Staff',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'staff-index',
      meta: {
        permission: 'staff.view',
      },
      beforeEnter: checkPermission('staff.view'),
      component: StaffIndex,
    },
  ],
}
